import { precompileTemplate } from "@ember/template-compilation";
export default precompileTemplate("",{ moduleName: "mewe/pods/components/basic-ui/storybook-inputs/template.hbs" })